import React from 'react';
import { TopToolbar, RefreshButton, number, minValue, maxValue, SelectInput, Toolbar, SaveButton, ListButton, ShowButton, Edit, SimpleForm, ArrayInput, TextField, TextInput, SimpleFormIterator, NumberInput, ReferenceField } from 'react-admin';
import { monthList } from '../common/common';
import Card from '@mui/material/Card';
import { withStyles } from '@mui/material/styles';


const EditToolbar = (props) => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);

const validNumber = [number(), minValue(0), maxValue(99999999)];

const PriceUpdateEdit = props => {
    console.log('props inside price update==>', props);
    return (
        <Edit {...props}>
            <SimpleForm toolbar={<EditToolbar />}>
                <TextField source="client_category_code" label="Payment ID" />
                <TextField source="material_description" label="Material Description" />
                <TextField source="material_number" label="Material Number" />
                <TextField source="name" label="Name" />
                {/* <FormattedCurrencyNumberCustom source="price_after_tax" label={`Amount(${curr})`} /> */}
                <NumberInput source="price_after_tax" label="Price After Tax" type="number" min="0" max="99999999" validate={validNumber}/>
                <SelectInput className="edit-user-small-textfield" source="status" choices={[
                    { id: true, name: 'true' },
                    { id: false, name: 'false' },
                ]}
                    defaultValue="status"
                />
            </SimpleForm>
        </Edit>
    )
};

export default PriceUpdateEdit;